import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { listReminders, createReminder, updateReminder, deleteReminder } from './api'

export function useReminders(accountId: string, opts?: { done?: boolean }) {
  return useQuery({
    queryKey: ['reminders', accountId, opts ?? {}],
    queryFn: () => listReminders(accountId, opts),
    enabled: !!accountId,
    staleTime: 10000,
  })
}

export function useCreateReminder() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      accountId,
      data,
    }: {
      accountId: string
      data: Parameters<typeof createReminder>[1]
    }) => createReminder(accountId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reminders'] })
    },
  })
}

export function useUpdateReminder() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      id,
      accountId,
      updates,
    }: {
      id: string
      accountId: string
      updates: Parameters<typeof updateReminder>[2]
    }) => updateReminder(id, accountId, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reminders'] })
    },
  })
}

export function useDeleteReminder() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, accountId }: { id: string; accountId: string }) =>
      deleteReminder(id, accountId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reminders'] })
    },
  })
}
